import { languageMap } from ".."
import { bracketIndenting } from "./shared"

languageMap.llvm = bracketIndenting({
	line: ";",
})
